module.exports = __webpack_public_path__ + "static/019-dabb57daa978992bd177d7b223b08d42.jpg";